do ($ = jQuery, window, document) ->
  pluginName = "tededCardlist"
  defaults =
    next: '[title="Next"]'
    prev: '[title="Previous"]'
    slider: '[data-slider]'

  # Debounce and SmartResize (in jQuery) ported to CoffeeScript
  # debouncing function from John Hann
  # http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
  debounce = (func, threshold, execAsap) ->
    timeout = false

    return debounced = ->
      obj = this
      args = arguments

      delayed = ->
        func.apply(obj, args) unless execAsap
        timeout = null

      if timeout
        clearTimeout(timeout)
      else if (execAsap)
        func.apply(obj, args)

      timeout = setTimeout delayed, threshold || 100

  sum = (a, b) => parseInt(a, 10) + parseInt(b, 10)

  class TededCardlist
    constructor: (@element, options) ->
      @settings = $.extend {}, defaults, options
      @$element = $(@element)
      @responsive = @$element.data("responsive") || false
      @index = @$element.data("start-on") || @settings.initialSlide || 0
      @$prev = @$element.find(@settings.prev)
      @$next = @$element.find(@settings.next)
      @$slider = @$element.find(@settings.slider)
      @$slides = @$slider.children() if @$slider.length

      if @$slides.length < 1
        console.error 'No slides found.'
        return false
      @init()

    init: ->
      @$element.off "click.#{pluginName}.next"
      @$element.on "click.#{pluginName}.next", @settings.next, (e) =>
        e.preventDefault()
        e.target.blur()
        @next()
      if @$element.find(@$next).length < 1
        @appendBtn(@$next, 'next')

      @$element.off "click.#{pluginName}.prev"
      @$element.on "click.#{pluginName}.prev", @settings.prev, (e) =>
        e.preventDefault()
        e.target.blur()
        @prev(e)
      if @$element.find(@$prev).length < 1
        @appendBtn(@$prev, 'prev')

      if @index > 0
        @goTo(@index)

      @updateBtns(0)

      # Bind events
      $(window).on "resize", debounce(@afterResize, 300)

    afterResize: =>
      @goTo(@index)

    next: ->
      @goTo (Math.min @index + 1, @$slides.length), "next"

    prev: ->
      @goTo (Math.max @index - 1, 0), "prev"

    getGrid: () ->
      columns = @$slider.css('grid-template-columns').match(/([\d\.]+)px/g)
      columns = if (!Array.isArray(columns)) then [] else columns
      return {
        columns: columns.map((col) => parseInt(col, 10))
        gap: parseInt(@$slider.css('grid-column-gap'), 10)
      }

    getColumnOffset: (idx) ->
      { columns, gap } = @getGrid()

      columnsWidth = columns.slice(0, idx).reduce(sum, 0)
      gapsWidth = parseInt(gap, 10) * idx

      return columnsWidth + gapsWidth

    goTo: (index, dir) ->
      $slide = @$slides.eq(index)
      return false if $slide.length == 0

      @updateFocus($slide, dir) if dir

      @index = index
      offsetX = @getColumnOffset(@index)
      @updateBtns(offsetX)
      @$slider.css 'transform', "translate3d(#{Math.ceil(offsetX * -1)}px, 0, 0)"
      return

    getMaxIndex: (offsetX) ->
      lastIndex = @$slides.length - 1
      slider = @$slider.get(0).getBoundingClientRect()
      lastSlide = @$slides[lastIndex].getBoundingClientRect()
      lastSlideEdge = @getColumnOffset(lastIndex) + lastSlide.width

      return lastSlideEdge <= slider.width + offsetX

    updateBtns: (offset) ->
      @toggleBtn(@$prev, @index > 0)
      @toggleBtn(@$next, !@getMaxIndex(offset) && @index < @$slides.length - 1)

    toggleBtn: ($btn, active) ->
      $btn.css 'opacity', +(active)
      if (active)
        $btn.removeAttr('disabled')
      else
        $btn.attr('disabled', "disabled")

    updateFocus: ($slide, dir) ->
      focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      if $slide.find(focusable).length
        $slide.find(focusable).focus()
      else
        $btn = if dir == "next" then @$next else @$prev
        $reverse = if dir == "next" then @$prev else @$next
        $btn = $reverse if $btn.is(":disabled")
        $btn.focus()

  $.fn[pluginName] = (options) ->
    @each ->
      if !$.data(@, "plugin_#{pluginName}")
        $.data(@, "plugin_#{pluginName}", new TededCardlist(@, options))

$(document).on 'turbo:load', ->
  $('[data-cardlist]').tededCardlist()
  $(document).ajaxComplete () ->
    $('[data-cardlist]').tededCardlist()